import React from "react";
import { MessageCircle, MapPin, Mail, Instagram } from "lucide-react";
import { WHATSAPP_NUMBER } from "@/lib/api";

const Footer = () => {
  const wa = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    "Halo Winselindo, saya ingin bertanya tentang produk."
  )}`;

  return (
    <footer id="footer" className="relative bg-[#0a0a0a] border-t border-white/10 pt-24 pb-10 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row justify-between gap-12 pb-16 border-b border-white/10">
          <div className="max-w-md">
            <h3 className="font-display font-black text-white text-4xl md:text-5xl tracking-tighter leading-none">
              Siap upgrade <br /> gadgetmu?
            </h3>
            <p className="font-body text-white/50 mt-5">
              Chat langsung dengan tim Winselindo untuk konsultasi & pemesanan. Respon cepat, ramah, dan profesional.
            </p>
            <a
              href={wa}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-whatsapp"
              className="inline-flex items-center gap-3 mt-8 bg-gradient-wl text-white rounded-full px-7 py-4 font-body font-semibold hover:opacity-90 transition-opacity"
            >
              <MessageCircle className="w-5 h-5" />
              Chat via WhatsApp
            </a>
          </div>

          <div className="grid grid-cols-2 gap-10">
            <div>
              <h4 className="font-body text-white font-semibold mb-4 text-sm uppercase tracking-wider">Navigasi</h4>
              <ul className="space-y-3 font-body text-white/50 text-sm">
                <li><a href="#katalog" className="hover:text-white transition-colors">Produk</a></li>
                <li><a href="#manifesto" className="hover:text-white transition-colors">Tentang Kami</a></li>
                <li><a href="#testimoni" className="hover:text-white transition-colors">Testimoni</a></li>
              </ul>
            </div>
            <div>
              <h4 className="font-body text-white font-semibold mb-4 text-sm uppercase tracking-wider">Kontak</h4>
              <ul className="space-y-3 font-body text-white/50 text-sm">
                <li className="flex items-center gap-2"><MessageCircle className="w-4 h-4 text-accent-wl" /> 0895-2565-2283</li>
                <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-accent-wl" /> winselindo@yahoo.com</li>
                <li className="flex items-center gap-2"><Instagram className="w-4 h-4 text-accent-wl" /> @winselindo.id</li>
                <li className="flex items-center gap-2"><MapPin className="w-4 h-4 text-accent-wl" /> Jakarta, Indonesia</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-8">
          <span className="flex items-center gap-3">
            <img src="/winselindo-mark.png" alt="Winselindo" className="h-7 w-auto" />
            <span className="font-display font-black text-2xl tracking-tighter text-white">WINSELINDO</span>
          </span>
          <p className="font-body text-white/30 text-sm">
            © {new Date().getFullYear()} Winselindo. Semua produk original & bergaransi resmi.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
